import { colors } from 'baseui/tokens';
import StyleBreakpoint from 'common/styles/styles.breakpoint';
import { themedStyled } from 'common/styles/styletron.theme';
import Text from 'components/elements/text';

export const SeparatorHorizontal = themedStyled<'div', { $margin: number }>(
  'div',
  ({ $margin = 0 }) => ({
    marginLeft: `${$margin / 2}px`,
    marginRight: `${$margin / 2}px`,
  }),
);

export const SeparatorVertical = themedStyled<'div', { $margin: number }>(
  'div',
  ({ $margin = 0 }) => ({
    marginTop: `${$margin / 2}px`,
    marginBottom: `${$margin / 2}px`,
  }),
);

export const WebSeparatorHorizontal = themedStyled<'div', { $margin: number }>(
  'div',
  ({ $margin = 0 }) => ({
    marginLeft: `${$margin}px`,
    marginRight: `${$margin}px`,

    [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
      display: 'none',
    },
  }),
);

export const WebSeparatorVertical = themedStyled<'div', { $margin: number }>(
  'div',
  ({ $margin = 0 }) => ({
    marginTop: `${$margin}px`,
    marginBottom: `${$margin}px`,

    [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
      display: 'none',
    },
  }),
);

export const TableContainer = themedStyled('div', {
  flex: 1,
  width: '100%',
  minHeight: '300px',
  flexDirection: 'column',
  display: 'flex',
});

export const Container = themedStyled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const FullContainer = themedStyled('div', {
  width: '100%',
});

export const HalfContainer = themedStyled('div', {
  width: '47%',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    width: '100%',
  },
});

export const SectionContainer = themedStyled('div', {
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
  },
});

export const TitleContainer = themedStyled('div', {
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '16px',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
  },
});

export const CardContent = themedStyled<
  'div',
  {
    $noPadding?: boolean;
  }
>('div', ({ $noPadding }) => ({
  padding: $noPadding ? '0px' : '16px',
  overflow: 'overlay',
}));

export const RightActionContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  [$theme.mediaQuery.maxLg]: {
    justifyContent: 'flex-end',
    marginBottom: '16px',
  },
}));

export const LeftActionContainer = themedStyled<'div', { margin?: boolean }>(
  'div',
  ({ $theme, margin = true }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    flexGrow: 1,

    [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
      ...(margin
        ? {
            marginBottom: '16px',
          }
        : {}),
    },
  }),
);

export const TopContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: $theme.sizing.scale800,
  justifyContent: 'space-between',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
    alignItems: 'unset',
  },
}));

export const LeftContainer = themedStyled('div', {});

export const RightContainer = themedStyled('div', {
  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    marginTop: '16px',
  },
});

export const RightRefreshContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  marginLeft: '8px',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    alignItems: 'flex-start',
    marginLeft: '0px',
    justifyContent: 'flex-start',
  },
});

export const CenteredDiv = themedStyled('div', {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const ActionContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const Action = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px 8px',
  borderRadius: '8px',
  ':hover': {
    backgroundColor: $theme.colors.primaryLightest,
  },
}));

export const DetailActionContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  justifyContent: 'end',
  alignItems: 'end',
  marginBottom: '16px',
});

export const StickyBottomButtonContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  position: 'sticky',
  // right: 0,
  bottom: '-16px',
  background: 'white',
  // boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
  // WebkitBoxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
  boxShadow: 'rgb(0 0 0 / 20%) 0px -4px 3px 0px',
  WebkitBoxShadow: 'rgb(0 0 0 / 20%) 0px -4px 3px 0px',
  left: 0,
  padding: '16px',
  paddingBottom: '16px',
  marginTop: 'auto',
  marginLeft: '-16px',
  marginRight: '-16px',
  // marginBottom: "-16px",
  zIndex: 99,
});

export const DesktopContainer = themedStyled('div', {
  display: 'initial',
  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    display: 'none',
  },
});

export const MobileContainer = themedStyled('div', {
  display: 'none',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    display: 'initial',
  },
});

export const styles = {
  tabPanel: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '200px',
    flexGrow: 1,
    height: '100%',
    padding: '24px 0px 0px 0px !important',
  },
  tab: {
    padding: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '200px',
    flexGrow: 1,
    height: '100%',
  },
  tabList: {
    minHeight: '41.48px',
  },
  tabBorder: {
    height: '3px',
  },
  tabHighlight: {
    height: '3px',
    bottom: '2px',
  },
  radioInner: ({ $checked, $theme }) => {
    // ...props.selected? : {}
    // background: "red",
    return {
      ...($checked
        ? {
            width: '10px',
            height: '10px',
            backgroundColor: $theme.colors.secondaryDark,
          }
        : {
            width: '16px',
            height: '16px',
          }),
    };
  },
  radioOuter: ({ $checked, $theme }) => {
    // ...props.selected? : {}
    // backgroundColor: "red",
    return {
      ...($checked
        ? {
            border: `2px solid ${$theme.colors.secondaryDark}`,
            backgroundColor: 'white',
            ':hover': {
              backgroundColor: 'white !important',
            },
          }
        : {}),
    };
  },
};

export const DetailContainer = themedStyled('div', {
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const TotalContainer = themedStyled('div', {});

export const CardContainer = themedStyled('div', ({ $theme }) => ({
  border: `0.5px solid ${$theme.colors.skyLight}`,
  padding: '20px',
  borderRadius: '8px',
}));

export const CardHeader = themedStyled('div', {
  marginBottom: '24px',
});

export const FooterDivider = themedStyled('div', {
  marginTop: '100px',
});

export const TopFormContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  marginBottom: '16px',
  gap: '16px',

  [`@media screen and (max-width: calc(${StyleBreakpoint.xl} - 1px))`]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
});

export const ButtonContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
});

export const HeaderContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

export const OneThirdContainer = themedStyled('div', ({ $theme }) => ({
  width: '30%',
  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    width: '100%',
  },
}));

export const OneQuarterContainer = themedStyled('div', ({ $theme }) => ({
  width: '22%',
  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    width: '100%',
  },
}));

export const OneFifthContainer = themedStyled('div', ({ $theme }) => ({
  width: '18%',
  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    width: '100%',
  },
}));

export const CardSection = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '16px',
  background: '#FFFFFF',
  border: '2px solid #E2E2E2',
  borderRadius: '8px',
}));

export const PillStatus = themedStyled<
  'div',
  { status: 'green' | 'red' | 'yellow' | 'blue' | 'other' | 'brown' }
>('div', ({ status, $theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  borderRadius: '999px',
  padding: '4px 8px',
  lineHeight: '14px',
  backgroundColor:
    status === 'green'
      ? colors.green400
      : status === 'yellow'
      ? colors.yellow400
      : status === 'red'
      ? colors.red400
      : status === 'blue'
      ? $theme.colors.primaryDefault
      : status === 'brown'
      ? colors.brown400
      : colors.gray400,
  color: status === 'yellow' ? $theme.colors.font : 'white',
  minWidth: '78px',
  fontSize: '14px',
}));

export const NotificationBadge = themedStyled<
  'div',
  { status?: 'yellow' | 'red' | 'orange' | 'green' | 'grey' | 'main' }
>('div', ({ status: _status, $theme }) => {
  const status = () => {
    switch (_status) {
      case 'green':
        return {
          backgroundColor: colors.green400,
          color: 'white',
        };
      case 'grey':
        return {
          backgroundColor: colors.gray400,
          color: 'white',
        };
      case 'main':
        return {
          backgroundColor: $theme.colors.primaryDefault,
          color: 'white',
        };
      case 'orange':
        return {
          backgroundColor: colors.orange400,
          color: 'white',
        };
      case 'red':
        return {
          backgroundColor: colors.red400,
          color: 'white',
        };
      case 'yellow':
        return {
          backgroundColor: colors.yellow400,
          color: $theme.colors.font,
        };
      default:
        return {};
    }
  };
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'fit-content',
    borderRadius: '8px',
    padding: '4px 8px',
    lineHeight: '14px',
    minWidth: '33px',
    fontSize: '14px',
    ...status(),
  };
});

export const InputBoxContainer = themedStyled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '8px',
  padding: '8px 14px',
  backgroundColor: '#EEEEEE',
  borderRadius: '8px',
});

export const ActionTrigger = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  padding: '6px 24px',
  borderRadius: '8px !important',
  background: 'white',
  border: `2px solid ${$theme.colors.primaryDefault}`,
  color: $theme.colors.primaryDefault,
  display: 'flex',
  alignItems: 'center',

  ':hover': {
    background: $theme.colors.primaryLightest,
    border: `2px solid ${$theme.colors.primaryDefault}`,
  },
  ':active': {
    background: $theme.colors.primaryLightest,
    border: `2px solid ${$theme.colors.primaryLight}`,
  },
  ...$theme.typography.body2Semibold,
}));

export const ActionContent = themedStyled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  backgroundColor: 'white',
  borderRadius: '8px',
  overflow: 'hidden',
});

export const ActionItemButton = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  background: $theme.colors.white,
  color: $theme.colors.primaryDefault,
  padding: '8px 24px',
  justifyContent: 'flex-start',
  ':hover': {
    background: $theme.colors.primaryLightest,
  },
  ':active': {
    background: $theme.colors.primaryLighter,
  },
  ...$theme.typography.body2Semibold,
}));

export const PopoverActionContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  backgroundColor: 'white',
  borderRadius: '8px',
  overflow: 'hidden',
});

export const PopoverActionTrigger = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  padding: '8px 24px',
  borderRadius: '8px !important',
  background: 'white',
  border: `1px solid ${$theme.colors.primaryDefault}`,
  color: $theme.colors.primaryDefault,
  display: 'flex',
  alignItems: 'center',

  ':hover': {
    background: $theme.colors.primaryLightest,
    border: `1px solid ${$theme.colors.primaryDefault}`,
  },
  ':active': {
    background: $theme.colors.primaryLightest,
    border: `1px solid ${$theme.colors.primaryLight}`,
  },
  ...$theme.typography.body3Semibold,
}));

export const PopoverActionItemButton = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  background: $theme.colors.white,
  color: $theme.colors.primaryDefault,
  padding: '8px 24px',
  justifyContent: 'flex-start',
  ':hover': {
    background: $theme.colors.primaryLightest,
  },
  ':active': {
    background: $theme.colors.primaryLighter,
  },
  ...$theme.typography.body2Semibold,
}));

export const FormContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  marginTop: '-16px',
  marginLeft: '-16px',
  marginRight: '-16px',
  paddingTop: '16px',
  paddingLeft: '16px',
  paddingRight: '16px',
  overflow: 'scroll',
}));

export const SummaryContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 199,
  boxShadow: '0px -4px 16px rgba(0, 0, 0, 0.12)',
  borderRadius: '8px 8px 0px 0px',
  padding: '16px',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}));

export const FormDivider = themedStyled('div', {
  marginTop: '120px',
});

export const SummaryLeftContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const SummaryRightContainer = themedStyled(
  SummaryLeftContainer,
  ({ $theme }) => ({
    marginTop: '16px',
    justifyContent: 'space-between',
    flex: 1,
    [$theme.mediaQuery.md]: {
      flex: 0,
      marginTop: 0,
    },
  }),
);

export const ItemCenter = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const TableCell = themedStyled('div', {
  display: 'flex',
});

export const Title = themedStyled(Text, {
  whiteSpace: 'nowrap',
  // maxWidth: '90%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const Row = themedStyled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const DialogCommonStyles = {
  Root: {
    style: {
      zIndex: 300,
    },
  },
  Dialog: {
    style: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

export const RowBetweenStyles = {
  display: 'flex',
  justifyContent: 'space-between',
};

export const EmptyTabStyles = {
  tabList: { minHeight: '0px' },
  tab: { minHeight: '0px', height: '0', flexGrow: '0' },
  tabPanel: { minHeight: '0px', height: '0', flexGrow: '0' },
};
